<template>
  <div class="d-post-poll-compare-images grid-2">
    <div class="grid-item">
      <div
        v-if="!!options[0].imageSrc"
        class="image-container space-top-1em"
      >
        <button
          class="button-icon button-close button-sm"
          title="Remove image"
          @click="removeImage(options[0])"
        />
        <img :src="options[0].imageSrc">
      </div>

      <DuiFileUpload
        v-else
        :accepted-types="acceptedTypes"
        upload-button-text="Upload an image"
        class="space-top-1em"
        title="Upload an image"
        @file-updated="updateImage1"
      />

      <input
        v-model="options[0].label"
        class="input-full space-top-1em"
        placeholder="Option 1"
        type="text"
      >
    </div>

    <div class="grid-item">
      <div
        v-if="!!options[1].imageSrc"
        class="image-container space-top-1em"
      >
        <button
          class="button-icon button-close button-sm"
          title="Remove image"
          @click="removeImage(options[1])"
        />
        <img :src="options[1].imageSrc">
      </div>

      <DuiFileUpload
        v-else
        :accepted-types="acceptedTypes"
        upload-button-text="Upload an image"
        class="space-top-1em"
        title="Upload an image"
        @file-updated="updateImage2"
      />

      <input
        v-model="options[1].label"
        class="input-full space-top-1em"
        placeholder="Option 2"
        type="text"
      >
    </div>
  </div>
</template>

<script>
import { POST_TYPES } from '@d-shared/config';

export default {
  props: {
    postInfo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    acceptedTypes: [
      'image/jpeg',
      'image/png',
    ],
    isLoadingData: false,
    options: [
      {
        imageFile: null,
        imageSrc: null,
        label: null,
      },
      {
        imageFile: null,
        imageSrc: null,
        label: null,
      },
    ],
  }),
  watch: {
    options: {
      deep: true,
      handler: function() {
        this.savePostInfo();
      },
    },
  },
  beforeDestroy() {
    this.clearPostInfo();
  },
  mounted() {
    this.setEditingContent();
  },
  methods: {
    clearPostInfo() {
      this.$set(this.postInfo, 'compareImages', null);
    },

    removeImage(option) {
      this.$set(option, 'imageFile', null);
      this.$set(option, 'imageSrc', null);
      this.clearPostInfo();
    },

    savePostInfo() {
      if (this.isLoadingData) {
        return;
      }

      const isLabelMissing = this.options.find(o => !o.label);
      if (isLabelMissing) {
        this.clearPostInfo();
        return;
      }

      const isImageMissing = this.options.find(o => !o.imageSrc);
      if (isImageMissing) {
        this.clearPostInfo();
        return;
      }

      this.$set(this.postInfo, 'compareImages', {
        image1: {
          file: this.options[0].imageFile,
          label: this.options[0].label,
          src: this.options[0].imageSrc,
        },
        image2: {
          file: this.options[1].imageFile,
          label: this.options[1].label,
          src: this.options[1].imageSrc,
        },
      });
    },

    setEditingContent() {
      if (!this.postInfo.compareImages) {
        return;
      }

      this.$set(this, 'isLoadingData', true);
      this.$set(this.options[0], 'imageSrc', this.postInfo.compareImages.image1.src);
      this.$set(this.options[0], 'label', this.postInfo.compareImages.image1.label);
      this.$set(this.options[1], 'imageSrc', this.postInfo.compareImages.image2.src);
      this.$set(this.options[1], 'label', this.postInfo.compareImages.image2.label);
      this.$set(this, 'isLoadingData', false);
    },

    updateImage(option, imageFile) {
      this.$set(option, 'imageFile', imageFile);
      this.$set(option, 'imageSrc', URL.createObjectURL(imageFile));
    },

    updateImage1(imageFile) {
      this.updateImage(this.options[0], imageFile);
    },

    updateImage2(imageFile) {
      this.updateImage(this.options[1], imageFile);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-post-poll-compare-images {
  .image-container {
    position: relative;

    img {
      border-radius: $border-radius-lg;
      display: flex;
    }

    button {
      position: absolute;
      right: $_2em;
      top: $_2em;
      z-index: 1;
    }
  }
}
</style>
